import React from "react";
import { twMerge } from "tailwind-merge";

export const SKELETON_BLOCK_CLASS = "rounded-md2 bg-black/[0.06]";

/** Single pulse block — compose layouts with Skeleton. */
export function SkeletonBlock({ className = "", ...rest }) {
  return <div className={twMerge(SKELETON_BLOCK_CLASS, className)} {...rest} />;
}

/**
 * Quiet loading placeholder shell.
 * Wrap SkeletonBlock children; pulse animation applies to the whole group.
 */
export default function Skeleton({
  label = "Loading…",
  className = "",
  children,
  ...rest
}) {
  return (
    <div
      className={twMerge("animate-pulse motion-reduce:animate-none", className)}
      aria-busy="true"
      aria-label={label}
      {...rest}
    >
      {children}
      <p className="sr-only">{label}</p>
    </div>
  );
}
